import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import Resource from '../Resource'
import { EduSectionTitle } from '../constants'
import { useHistory } from 'react-router-dom'
import ReactHlsPlayer from 'react-hls-player';

class Toast extends React.Component {
  render() {
    return (
      <div
        className={`ToastBackground ${this.props.visible && 'visible'}`}
        onClick={this.props.onDismiss}
      >
        <div className="Toast" onClick={(e) => e.stopPropagation()}>
          {this.props.children}
        </div>
      </div>
    )
  }
}

class CompleteAnimationContainer extends React.Component {
  state = {
    in: false,
  }

  componentDidMount() {
    setTimeout(() => this.setState({ in: true }), 1000)
  }

  render() {
    return (
      <div className="StarContainer">
        <h2>Completed!</h2>
        {[
          { top: 13, left: -2, sym: 1 },
          { top: 20, left: 12, sym: 2 },
          { top: 15, left: 20, sym: 3 },
          { top: 25, left: 65, sym: 1 },
          { top: 32, left: 97, sym: 2 },
          { top: 44, left: 20, sym: 3 },
          { top: 55, left: 11, sym: 1 },
          { top: 63, left: 38, sym: 2 },
          { top: 45, left: -2, sym: 3 },
          { top: 53, left: 82, sym: 1 },
          { top: 42, left: 85, sym: 3 },
          { top: 15, left: 90, sym: 1 },
        ].map(({ top, left, sym }, idx) => (
          <img
            alt={'+'}
            className="plus"
            width={[26, 21, 15][sym - 1]}
            height={[26, 21, 15][sym - 1]}
            style={{
              top: this.state.in ? top + '%' : '40%',
              left: this.state.in ? left + '%' : '50%',
              opacity: this.state.in ? 1 : 0,
              transitionDelay: `${idx * 40}ms`,
            }}
            src={require(`../images/completion_plus_${sym}.png`)}
          />
        ))}
        <img
          className="star"
          alt={'star'}
          src={require('../images/completion_star.png')}
          style={{ transform: this.state.in ? `scale3d(1,1,1)` : `scale3d(0.01,1,1)` }}
          width={194}
        />
        <p>Your activity has been recorded. Keep up the good work!</p>
        <button className="block" onClick={this.props.onDismiss}>
          {this.props.saving ? 'Saving...' : 'OK'}
        </button>
      </div>
    )
  }
}

export default function VideoDetailContainer(props) {
  let _videoStartTime = 0
  const _videoRef = React.createRef()
  const playerRef = React.useRef();
  const endedHandledRef = React.useRef(false);

  const [showToast, setShowToast] = useState(false)
  const [saving, setSaving] = useState(false)

  const history = useHistory()

  useEffect(() => {
    ensureVideoEvent()
    return () => {
      const videoEl = _videoRef.current
      if (!videoEl) return
      videoEl.removeEventListener('webkitendfullscreen', onFullscreenEnd)
    }
  })

  const ensureVideoEvent = () => {
    const videoEl = _videoRef.current
    if (!videoEl) return

    videoEl.removeEventListener('webkitendfullscreen', onFullscreenEnd)
    videoEl.addEventListener('webkitendfullscreen', onFullscreenEnd)
  }

  const onFullscreenEnd = (e) => {
    e.target.dispatchEvent(new Event('ended', {}))
  }

  const onBack = () => {
    props.screenContainerRef.current.classList.add('out')
    setTimeout(() => {
      history.push('/mobile/videos')
    }, 400)
  }

  const onPlayVideo = () => {
    // reset ended guard for a new playback
    endedHandledRef.current = false;
    _videoStartTime = Date.now()

    const videoPlayer = document.getElementById('video-player')
    videoPlayer.controls = true
    videoPlayer.play()
  }

  const onVideoEnded = (video) => {
    // ensure this handler only runs once per playback
    if (endedHandledRef.current) return
    endedHandledRef.current = true
    const videoPlayer = document.getElementById('video-player')
    if (videoPlayer.webkitExitFullscreen) {
      videoPlayer.webkitExitFullscreen()
    }
    if (Date.now() - _videoStartTime > 10 * 1000) {
      //todo - make this 1/3 of the total video length instead of 10 seconds
      video.complete = true // directly modify cache
      props.onRecordView(video.id)
      setShowToast(true)
    } else {
      alert(
        "Uh-oh - to get credit for watching this video, you'll need to watch more of the video."
      )
    }
  }

  const playVideo = () => {
    playerRef.current.play();
  }

  const pauseVideo = () => {
    playerRef.current.pause();
  }

  const toggleControls = () => {
    playerRef.current.controls = !playerRef.current.controls;
  }

  const onDismissToast = async (isEducational) => {
    setSaving(true)
    setTimeout(() => {
      setShowToast(false)
      if (isEducational) {
        history.push('/mobile/videos')
      } else {
        history.push('/mobile/submit-rpe')
      }
    }, 400)
  }

  return (
    <div className="screen video-detail">
      <div className="navigation-bar">
        <div className="button-item back" onClick={onBack}>
          <img src={require('../images/icon_back_arrow.png')} alt="arrow" className="arrow" />
          Back
        </div>
        <div className="title">Exercise</div>
      </div>
      <Resource collection path={['videos']} placeholder={[]}>
        {(sections) => {
          let video = null
          let section = null

          sections.forEach((s) =>
            s.videos.forEach((v) => {
              if (v.id / 1 === props.videoId / 1) {
                video = v
                section = s
              }
            })
          )
          if (!video) {
            return <div>Video not found.</div>
          }

          const isEducational = section.title === EduSectionTitle

          return (
            <div className="content-flex">
              <h3>{video.title}</h3>
              {/* <video
                ref={_videoRef}
                id="video-player"
                className="poster"
                poster={video.posterImageURL}
                onEnded={() => onVideoEnded(video)}
              >
                <source
                  src={`${video.hlsDirectoryURL}/playlist.m3u8`}
                  type="application/x-mpegURL"
                />
                <source src={`${video.hlsDirectoryURL}/480p.mp4`} type="video/mp4" />
              </video> */}

              <ReactHlsPlayer
                playerRef={_videoRef}
                id="video-player"
                className="poster"
                src={`${video.hlsDirectoryURL}/playlist.m3u8`}
                // src="https://bdoc-backend-local-chime-meeting-recordings.s3.us-east-1.amazonaws.com/45067852-87e2-461c-b7b3-f6c7a7bb2713/composited-video/ts/index.m3u8?response-content-disposition=inline&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEPn%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCXVzLWVhc3QtMSJHMEUCIEy08toR6hQ67YtwZum0I76Hr%2BS%2F9t2nND7zJdk7THVIAiEApbUO8BJLqwl7hRSCpZPOh0usBULIbepabLy2VsjPTy4qqQQIQhAAGgw2MjY2MzU0MDEwNzQiDP1VRmONwGTU4jzZGyqGBHAWpd4k5lC10LxIr6HFwQdFRij8FWuxRVfqkfRI6UwruyNvk6%2BLVAI1zwOEEFONclFiM6vlM7zAeiDA7a6%2F%2BtOqtHhypL4qo8TbKRtzo6iHm8A7OSkvJ1NgvH8u9RrFO%2FAujvhd2qJHi9gzNASpipo3N52fsxu1ToAe16DRgB%2FtJtPKdM08SGUmthRG2rgfTbT3TOd0PwUSjazksJTjWDxn4ZHTyok34EGNTGLLxRRXGDG1XPGvMfugaQB7vHOt%2FQ2SCHw9yVj7Nj6cONE0wlnmNhCLeWW7Vvg5EoQAyvSZd5RfdXOqFp33IWakQ5QbVf%2BxZPaBURnsmy03frYG%2BCjkY3wQmOhNN3nVTP4oefOV2pfNxvbM8Yj4huzmTLX6hyr4y2tZeO9XQ04pnrA1N9ZbrNklXNnmYzRXT%2Fn0s65MPsdCtL95qRK0jr2A1ltZtq1Psa500%2BgmJgVv5cHGOaCMHlAsDkGz3QzS7q7KbMixA5TlKfs8TUjgMuCykh7XoesrzvVIESVBxRcci5Fz1i8qHBpTLqj24Xr3akjL1UbrRk6hP0asRgY2WEOINxhcdodfrjQgeKtPcxxH3u6SlWdeaAmKbj0serjPPxQvGXoTLG5I3DMgBHxdLxeUASofgvCJ3hqZFHkSn%2F1XHXcrUOUxA7PYrFWf3DCnITTnpKBFqnyN7C3rMLj%2Bqb4GOsUCTCrfIhBN9izl9Canhm1oz4hPxiFaM45MWl5YjZ7iqbOYWq2z8mr0y0EOsI%2FtvJ%2B8uj3oZOc%2BW1D1T3reGuYnhyaDxCTh5uvpZ9GZ6mD131XtPXzGP763uo5GqGuDD2Fgd56oZTktM6yZFhNRRT3yu7uzLmGhzWYJRysiRhe60za0uIfiPTrmZRGsyXvBbgSaUt%2BYI1dVa2%2BACkamgCOSgF6zic2DWSragGbUJkRLg8tZSX29PbkpbxN9GWOnJS5vNW%2FLmlHevfW6ivo0p3zD%2FfRPzzC2bY5VANHjvWhBmCuMRFbcI0%2Fz2R9oHkfNlo%2BibzD9QoJ%2BmYc7ScmP9H4dTyJYNvI7dYGdBnWtm05ZCZWEFbOFk4GH2MyN4KEE55IpvfO4aGBE78emxQkXMjtwgvbeODfOADpZvq3IEe4pXTieTKA8pw%3D%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAZDZTBM5ZONWJSV73%2F20250307%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20250307T085319Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=1f0bb9f7d2cbfe746463ec6f7f6a5360fb39b3e3cc3215f7c6d0c606270860dc"
                width="100%"
                height="auto"
                poster={video.posterImageURL}
                onEnded={() => onVideoEnded(video)}
              />
              <p>{video.description || 'No description provided.'}</p>
              <div style={{ flex: 1 }} />
              <button className="black block" onClick={onPlayVideo}>
                {isEducational ? 'Start Video' : 'Start Exercise'}
              </button>

              <Toast visible={showToast} onDismiss={() => onDismissToast(isEducational)}>
                {showToast && (
                  <CompleteAnimationContainer
                    onDismiss={() => onDismissToast(isEducational)}
                    saving={saving}
                  />
                )}
              </Toast>
            </div>
          )
        }}
      </Resource>
    </div>
  )
}
